/*
  This is the summary
 */

import React, {useState} from 'react'
import Notice from '../Notice'
import { useSelector, useDispatch } from "react-redux";
import store from "../../store/store"
import SaveButtons from '../SaveButtons'
import SummaryError from "./SummaryError";
import { setQuantity} from "../../store/details/projectDetailsSlice";
import {setErrors} from "../../store/configuratorStateSlice";
import QuickshipDisplay from "../common_elements/QuickshipDisplay";

const Summary = (props) => {
    const dispatch = useDispatch();
    const summary = useSelector(state => state.summaryReducer);
    const quantity = useSelector(state => state.projectDetailsReducer.quantity);
    const currency = useSelector(state => state.projectDetailsReducer.currency);
    const projectType = useSelector(state => state.projectDetailsReducer.projectType);
    const priceBook = useSelector(state => state.projectDetailsReducer.priceBook);
    const agent = useSelector(state => state.agent);
    
    const handleFormChange = (event) => {
        if( event.target.value != "") {
            dispatch(setQuantity(event.target.value));
        }
    }


    const getCatalogNumber = () => {
        if(summary == null ){
            return;
        }

        return summary.catalog_number
    }

    const getProjectType = () => {
        if(projectType == null ){
            return;
        }

        return projectType
    }

    const getPrice = () => {
        if(summary == null ){
            return;
        }
        return `${currency} ${summary.price}`
    }

    const getPriceBook = () => {
        if(summary == null ){
            return;
        }
        return `${priceBook ? priceBook : "Needs Implementing"}`
    }

    const getQuantity = () => {
        if(quantity == null ){
            return;
        }
        return <input min="1" max="99999" style={{width: '6em'}} defaultValue={quantity} type="number" onChange={(e) => handleFormChange(e)} ></input>
    }

    const getTotal = () => {

        if(summary == null){
            return;
        }
        return `${currency} ${summary.total_price}`
    }

    const priceIsZero = () => {
        return summary.price == '$0.00'
    }

    
    // show error for users if price of product is equal to 0 - represents an null component price
    if(priceIsZero() && !agent.is_admin){
        // TODO uncomment causing issues with pricing
        // return ( <SummaryError error='Invalid Catalog Number'/>)
    }

    if(summary.is_invalid){
        return (<SummaryError error='Too many wiring options'/>)
    }

    if(summary.is_invalid){
        store.dispatch({type: 'ADD_ERROR', notice_type: 'catalog_number', message: 'Too many wiring options'})
        store.dispatch(setErrors(['Too many wiring Options']))
        return (<SummaryError />)
    }

    return (
        <div className="summary-wrapper">
            <div className="summary" id="summary-panel">
                <div className="panel">
                    <div className="row">
                        <div className="small-12 columns summary-title less-margin">
                            <h2>Summary - { getProjectType() } </h2>
                        </div>
                    </div>
                    <div className="row">
                        <Notice addPadding={true}/>
                        <div className="small-12 columns no-padding" >
                            <p className={'no-border-top'}>Catalog Number:
                                <span style={{'marginLeft': '0.2em'}}>
                                    { getCatalogNumber()}
                                </span>
                            </p>

                            <p>
                                <div className='row'>
                                    <div className="small-6 columns no-padding">
                                        Unit Price:
                                        <span style={{'marginLeft': '0.2em'}}>
                                            {getPrice()}
                                        </span>
                                    </div>
                                    <div className="small-6 columns no-padding">Price Book:
                                        <span style={{'marginLeft': '0.2em'}}>
                                            {getPriceBook()}
                                        </span>
                                    </div>
                                </div>
                            </p>


                            <p className="no-border">
                                <label> Quantity: </label>
                                { getQuantity()}
                            </p>

                            <p className="total-text">Total:
                                <span style={{'marginLeft': '0.2em'}}>
                                    {getTotal()}
                                </span>
                            </p>
                            <QuickshipDisplay />
                        </div>
                    </div>
                    <div className="row">
                        <SaveButtons />
                    </div>
                </div>
            </div>
        </div>
    )
    
}

export default Summary;